import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import AudioSegment from "models/audioEditor/segments/AudioSegment";
import RSVP from "rsvp";

const CLASSNAME = "DeletedAudioSegment";
const DeletedAudioSegment =  AudioSegment.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        AudioSegment.apply(this, [attributes, options]);
        this.set("type",DeletedAudioSegment.CLASSNAME);
        
    },

    clone: function(){
        return new DeletedAudioSegment(this.toJSON());
    },


});

DeletedAudioSegment.CLASSNAME = CLASSNAME;
export default DeletedAudioSegment; 